import { Node, mergeAttributes } from "@tiptap/core";

export const FacebookServerside = Node.create({
  name: "facebook",

  group: "block",
  content: "inline*",

  parseHTML() {
    return [
      {
        tag: 'a[data-type="facebook"]',
      },
    ];
  },
  addAttributes() {
    return {
      url: { default: null },
      "data-id": { default: null },
      class: { default: "inline-facebook" },
    };
  },
  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes(HTMLAttributes, {
        "data-type": "facebook",
        class: `react-renderer node-facebook ${HTMLAttributes.class}`,
      }),
      0,
    ];
  },
});
